/**
 * Funzioni API per il branding del portale (Admin — product-service).
 *
 * Endpoint:
 *   GET /api/products/branding         → Branding (tutti i ruoli, usato dall'header)
 *   PUT /api/products/admin/branding   → Branding (solo SYSTEM_CONFIGURATION)
 */

import { createServiceClient } from '../../api/client.js';
import type { Branding } from './branding-types.js';

const productApi = createServiceClient('product');

/** Recupera il branding corrente. GET /api/products/branding */
export function fetchBranding(): Promise<Branding> {
  return productApi<Branding>('/branding');
}

/** Imposta il logo. PUT /api/products/admin/branding */
export function updateBranding(logoUrl: string | null): Promise<Branding> {
  return productApi<Branding>('/admin/branding', {
    method: 'PUT',
    body: { logoUrl },
  });
}
